import SystemFieldProto from '../../proto/system-field-proto';

// @ts-ignore
import ListComponent from './components/open-all-list';
import {EntityType} from "../../../gd/const/item";
import ItemModel from "../../../model2/item/item-model";

//projects only field
export default class CommentsField extends SystemFieldProto {

    constructor(entityType:EntityType) {
        super(entityType);
        this.type = gd.const.fields.type.OPEN_ALL;
    }

    get sortHintMessage() {
        return 'Sort by tasks';
    }

    // @ts-ignore
    getCsvValue(item:any, listItem:ItemModel) {
        // tut bug est' - netu numChildren pochemu to ?
        const open  = (item.tasksOpen ? item.tasksOpen : 0) + listItem.numChildren?.tasksOpen || 0
        const total = (item.tasksTotal ? item.tasksTotal : 0) + listItem.numChildren?.tasksTotal || 0

        return open + "/" +total;
    }

    // @ts-ignore
    listItemSortFunctions(sort:any) {
        return {
            functions: [(i:any) => {
                const { tasksOpen/*, tasksTotal*/ } = i.item;

                const open = (tasksOpen ? tasksOpen : 0) + i.numChildren.tasksOpen
                return open
            }],
            directions: [sort]
        }
    }

    get ListComponent() {
        return ListComponent.bind(null);
    }
}